export default __webpack_public_path__ + "static/media/spirals-no-3.f3fdd4b5.ogg";